// /resources/js/app/core/DomElements.js

/**
 * Provides a single, centralized source for all DOM element queries.
 */
export const DomElements = {
    loadingMessage: document.getElementById('loading-message'),
    feedTable: document.getElementById('feed-table'),
    feedTableBody: document.getElementById('feed-table-body'),
    // Guest modal elements are no longer needed.
    monitoringControlPill: document.getElementById('monitoring-control-pill'),
    monitoringStatusDot: document.getElementById('monitoring-status-dot'),
    monitoringStatusText: document.getElementById('monitoring-status-text'),
    monitoringCallCounter: document.getElementById('monitoring-call-counter'),
};